/**
 * Checks for common email entry typos. Not meant to be a full email validation.
 */
export const isValidEmail = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
